import { useEventFormFormByIdQuery } from '@graphql/generated';

export const useFormById = (formId: string) => {
  const {
    data: dataRaw,
    loading,
    error,
  } = useEventFormFormByIdQuery({
    variables: {
      formByIdId: formId,
    },
    batchMode: 'fast',
  });

  const data = dataRaw?.formById;

  return { data, loading, error };
};
